<template>
    <common-content-spacer height="small">
        <common-content-wrapper width="huge">
            <div class="availibility-week-calendar--header">
                <div v-for="day in weekDays" :key="day.date" :class="dayClass(day)">
                    <p class="availibility-week-calendar__day">
                        {{ day.name }}
                    </p>
                    <p class="availibility-week-calendar__date">
                        {{ day.date }}
                    </p>
                </div>
            </div>
        </common-content-wrapper>
        <div class="availibility-week-calendar">
            <section class="appointment-calendar">
                <ol class="availibility-week-calendar__days">
                    <li v-for="(day, index) in monthDays" :key="index" class="availibility-week-calendar__calendar-day"></li>
                </ol>
            </section>
        </div>
    </common-content-spacer>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarMixin from 'mixins/CalendarMixin'
    import weekday from 'dayjs/plugin/weekday'
    dayjs.extend(weekday)

    export default {
        mixins: [CalendarMixin],

        props: {
            year: { type: Number, required: true },
            month: { type: Number, required: true },
        },

        computed: {
            weekDays() {
                return Array(7)
                    .fill(1)
                    .map((day, index) => ({
                        name: dayjs()
                            .day(index + 1)
                            .format('ddd')
                            .toUpperCase(),
                        date: dayjs()
                            .weekday(index + 1)
                            .date(),
                        isToday:
                            dayjs().year() === this.year &&
                            dayjs().month() === this.month &&
                            dayjs().date() &&
                            dayjs().date() ===
                                dayjs()
                                    .weekday(index + 1)
                                    .date(),
                    }))
            },
        },

        methods: {
            dayClass(day) {
                return {
                    'availibility-week-calendar--header__day': true,
                    'availibility-week-calendar--header__day--today': day.isToday,
                }
            },
        },
    }
</script>
